var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m3 6v18h18v-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1zm4-18v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2z"}));
}

Trash.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Trash;

Trash.default = Trash;
